export const styles = (theme) => ({
  root: {
    '@media print': {
      display: 'none',
    },
  },
  footer: {
    backgroundColor: theme.palette.common.white,
    paddingTop: 50,
    paddingBottom: 50,
  },
  subFooter: {
    backgroundColor: theme.palette.common.darkGrey,
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(6),
    color: theme.palette.common.midGrey3,
  },
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  footerLinks: {
    marginLeft: theme.spacing(2),
    '& > p:first-of-type': {
      marginLeft: 12,
    },
  },
  captionSmall: {
    fontSize: '0.75rem',
    lineHeight: 1.3,
  },
  subFooterLogo: {
    marginRight: 25,
  },
  subFooterText: {
    flex: 1,
    paddingRight: 40,
  },
  introText: {
    marginBottom: theme.spacing(2),
  },
  button: {
    textTransform: 'none',
    ...theme.typography.body1,
    color: theme.palette.common.midGrey1,
  },
  buttonIcon: {
    width: 25,
    height: 25,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    '& > span': {
      width: 21,
    },
    '& img': {
      maxWidth: 16,
      maxHeight: 18,
    },
  },
  buttonIconLinkedIn: {
    width: 25,
    height: 25,
    margin: 0,
    '& > span': {
      width: 21,
    },
  },
});
